import React from "react";
import SysStoreDetail from "../component/SysStoreDetail";

const SysStoreDetailContainer = () => (<SysStoreDetail />)

export default SysStoreDetailContainer;
